import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';

import { alertActions } from '../../../../_actions/alert.actions';
import { rolesService } from '../../../../_services/roles.service';
import { useRouteMatch } from 'react-router-dom';

export default function ListRoles({ history }) {
  let { path } = useRouteMatch();
  const dispatch = useDispatch(null)

  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [roles, setRoles] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const { page } = queryString.parse(history.location.search);

    setIsLoading(true)

    rolesService.retrieveRoles(page)
      .then(roles => {
        setRoles(roles.data)
        setTotal(roles.data.meta.total)
      })
      .catch((error) => {
        dispatch(alertActions.error('Could not retrieve roles at this time. Please try again.'));
      })
      .then(() => {
        setIsLoading(false)
    })
  }, [dispatch, history.location.search])

  useEffect(() => {
    let { page } = queryString.parse(history.location.search);

    if (!page) {
      page = 1
    }

    setPage(parseInt(page))

  }, [history.location.search])

  const renderStatus = (role) => {
    return role.deletedAt === null ?
      <span style={{opacity: '0.7', width: '70px'}} className="badge badge-success py-2">Active</span> :
      <span style={{opacity: '0.7', width: '70px'}} className="badge badge-danger py-2">Archived</span>
  }
 
  const columns = [
    {
      name: 'STATUS',
      width: '150px',
      sort: false,
      cell: role => {
        return renderStatus(role)
      }
    },
    {
      name: 'ROLE',
      sort: false,
      cell: role => {
        return <span className="badge badge-secondary py-2 px-3" style={{minWidth: '100px', background: 'RGBA(102, 135, 171, 0.7)'}}>{role.name}</span>
      }
    },
    {
      name: 'DESCRIPTION',
      sort: false,
      cell: role => {
        return <span className='text-muted font-weight-light'>{role.title}</span>
      }
    },
    {
      name: '',
      sort: false,
      cell: (role) => {
        if (role.deletedAt) {
          return
        }

        const label = role.userCount === 1 ? 'User' : 'Users';
        const colorClass = role.userCount > 0 ? 'badge-info' : 'badge-warning';

        return <div className='w-100 text-center'>
          <span className={`badge badge-pill ${colorClass}`}>{role.userCount} {label}</span>
        </div>
      }
    },
    {
      button: true,
      sort: false,
      width: '150px',
      cell: role => {
        return (role.deletedAt === null && role.name !== 'full-access') && <div onClick={() => history.push(`${path}/edit/${role.id}`)} className='message__view__btn px-5'>Edit</div>
      }
    }
  ];

  return (
    <>
      <header>
        <div className='lead mb-4 pt-2'>Roles</div>
      </header>

      <div className="axs-shadow axs-rounded p-1" style={{background: 'white'}}>
        <DataTable
          noHeader
          columns={columns}
          data={roles.data}
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <div className='w-100 d-flex justify-content-end'>
              <Button onClick={() => history.push(`${path}/add`)} className='px-5'>Add Role</Button>
            </div>
          }
          onChangePage={page => {
            history.replace(`/account/roles?page=${page}`)
          }}
          pagination={true}
          paginationServer={true}
          paginationTotalRows={total}
          paginationDefaultPage={page}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={15}
          customStyles={{ 
            cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
            headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
            subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
          }}
        />
      </div>
    </>
  )
}
